import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import BaseTable from '../../components/shared/table/BaseTable';
import { SubmissionListToolbar } from './SubmissionListToolbar';
import { useColumns } from './hooks/useColumns';
import SubmissionCard from './SubmissionCard';
import { useMediaQuery } from '../../hooks/useMediaQuery';
import { TableContext } from '../../components/shared/table/context/TableContext';

export const SubmissionListTable = ({
  submissions = [],
  type = 'active',
  onCheckStatus,
  checkingStatus = {},
}) => {
  const navigate = useNavigate();
  const { setColumns, filterRows } = useContext(TableContext);
  const columns = useColumns(submissions);
  const isMobile = useMediaQuery('(max-width: 768px)');
  const filteredSubmissions = filterRows(submissions);

  useEffect(() => {
    setColumns(columns);
  }, [columns, setColumns]);

  const actionColumn = {
    field: 'actions',
    headerName: 'Actions',
    width: 50,
    align: 'center',
    fixed: true,
    renderCell: (item) => {
      if (!item?.grading_service_name || item.grading_service_name !== 'PCGS') {
        return null;
      }

      return (
        <button
          type="button"
          className="px-2 py-1 text-xs font-medium text-indigo-600 hover:text-indigo-900 disabled:opacity-50 border border-indigo-600 rounded hover:bg-indigo-50"
          onClick={(e) => {
            e.stopPropagation();
            onCheckStatus(item.id);
          }}
          disabled={checkingStatus[item.id]}
        >
          {checkingStatus[item.id] ? (
            <div className="flex items-center">
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-indigo-600 mr-2"></div>
              Checking...
            </div>
          ) : (
            'Update'
          )}
        </button>
      );
    },
  };

  return (
    <div className="flex flex-col h-full min-h-0">
      <SubmissionListToolbar
        columns={columns}
        data={submissions}
        type={type}
        showQuickFilter={true}
        quickFilterProps={{ debounceMs: 300 }}
      />
      <div className="flex-1 min-h-0">
        {isMobile ? (
          <div className="p-4 space-y-4 bg-gray-50">
            {filteredSubmissions.map(submission => (
              <SubmissionCard
                key={submission.id}
                submission={submission}
                onCheckStatus={onCheckStatus}
                checkingStatus={checkingStatus}
              />
            ))}
          </div>
        ) : (
          <BaseTable
            data={filteredSubmissions}
            columns={[actionColumn, ...columns]}
            getRowClassName={(row) => row.in_history ? 'bg-gray-50' : undefined}
            onRowClick={(id, button, target) => {
              // Don't navigate if clicking a link, anchor tag, or button
              if (target?.closest('button') || target?.closest('a') || target?.closest('Link')) {
                return;
              }
              navigate(`/submissions/${id}`);
            }}
          />
        )}
      </div>
    </div>
  );
};
